import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Tab, Nav, Badge } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { WORK_TYPE_COLOURS, HARVEST_WORK_TYPE_IDS } from '../../../constants';
import { AvatarWithDropdownSelection } from '../utils';
import { SubNav } from '../../layout/submenu';
import { Filter, FilterBox } from '../../widgets';
import { setFieldSelectedWorkType, setSelectedFields, setFilteredFields, setSortBy } from '../../../actions/dashboard';
import { distinctKeys } from '../../../helpers/common';

const FieldHeader = (props) => {
  const { searchText, setSearchText } = props;
  const dispatch = useDispatch();
  const workTypeList = useSelector(state => state.dashboard.workTypeList.payload);
  const fieldListById = useSelector(state => state.dashboard.field.fieldListById.payload);
  const autoSelectedFieldIds = useSelector(state => state.dashboard.field.autoSelectedFieldIds);
  const selectedFieldIds = useSelector(state => state.dashboard.field.selectedFieldIds);
  const selectedWorkTypeIds = useSelector(state => state.dashboard.field.selectedWorkTypeIds);
  const sortBy = useSelector(state => state.dashboard.field.sortBy);
  const fieldFilter = useSelector(state => state.dashboard.field.fieldFilter);
  const isEnableHarvestProjection = useSelector(state => state.farm.currentFarm.is_harvest_projection_enable);
  const isAllPlan = useSelector(state => state.plan.isSelectAllPlan);

  const [isOpen, setIsOpen] = useState(false);
  const [fields, setFields] = useState([]);
  const [crops, setCrops] = useState([]);
  const [filters, setFilters] = useState(fieldFilter);

  useEffect(() => {
    const fields = Object.keys(fieldListById).map(e => ({
      id: fieldListById[e].geo_shape_uuid,
      name: fieldListById[e].geo_shape_name
    }));
    setFields(fields);

    const distinctCrops = distinctKeys(Object.keys(fieldListById).map(key =>
      fieldListById[key].regionDetails), "crop_name", false);
    setCrops(distinctCrops.map(e => ({ id: e, name: e })));
  }, [fieldListById, autoSelectedFieldIds, selectedFieldIds]);

  useEffect(() => {
    setFilters(fieldFilter);
  }, [isOpen]);

  const handleWorkType = (id) => {
    const list = [...selectedWorkTypeIds];

    if (list.indexOf(id) >= 0) list.splice(list.indexOf(id), 1);
    else {
      if (HARVEST_WORK_TYPE_IDS.indexOf(id) >= 0) {
        const harvestWorkTypeIds = selectedWorkTypeIds.filter(id => HARVEST_WORK_TYPE_IDS.indexOf(id) >= 0);
        if (harvestWorkTypeIds.length > 0) list.splice(list.indexOf(harvestWorkTypeIds[0]), 1);
        list.push(id);
      } else list.push(id);
    }

    dispatch(setFieldSelectedWorkType(list));
  };

  const handleSelect = (item, e, name) => {
    const id = item.id
    const { checked } = e.target;
    const selected = [...filters[name]];
    const indexOf = selected.indexOf(id);
    if (checked && indexOf < 0) selected.push(id);
    else if (!checked && indexOf >= 0) selected.splice(indexOf, 1);
    setFilters({ ...filters, [name]: [...selected] });
  }

  const handleSelectAllFields = (e) => {
    const { checked } = e.target;
    let selected = [...filters.fields];
    if (checked) {
      fields.forEach(e => { if (selected.indexOf(e.id) < 0) selected.push(e.id); });
      setFilters({ ...filters, "fields": [...selected] });
    }
    else if (!checked) setFilters({ ...filters, "fields": [] });
  }

  const handleSelectAllCrops = (e) => {
    const { checked } = e.target;
    let selected = [...filters["crops"]]
    if (checked) {
      crops.forEach(e => { if (selected.indexOf(e.id) < 0) selected.push(e.id); });
      setFilters({ ...filters, "crops": [...selected] });
    }
    else if (!checked) setFilters({ ...filters, "crops": [] });
  }

  const getFilterCount = (name) => {
    if (name)
      return filters[name] && filters[name].length > 0 ? filters[name].length : '';
    else {
      let total = 0;
      for (const key in fieldFilter) total += (fieldFilter[key].length > 0 ? 1 : 0);
      return total > 0 ? total : null;
    }
  };

  const handleReset = () => {
    setFilters({ fields: [], crops: [] });
    setSearchText("");
    dispatch(setFilteredFields({ fields: [], crops: [] }));
    dispatch(setSelectedFields([...autoSelectedFieldIds]));
  }

  const handleApply = () => {
    let fieldIds = fieldListById ? fieldListById : null;
    let selectedIds = [];
    if (filters.fields.length > 0) {
      selectedIds = filters.fields;
    }

    if (filters.crops.length > 0) {
      fieldIds = Object.keys(fieldIds).map(e => {
        let crop = fieldIds[e].regionDetails.crop_name;
        if (filters.crops.indexOf(crop) !== -1) return fieldIds[e].geo_shape_uuid;
        return null;
      }).filter(e => {
        if (e !== undefined) return e;
        return null
      })
      if (selectedIds.length > 0) {
        selectedIds = selectedIds.filter(e => fieldIds.includes(e));
      }
      else selectedIds = [...selectedIds, ...fieldIds];
    }

    dispatch(setSelectedFields(selectedIds));
    dispatch(setFilteredFields(filters));
    setIsOpen(false);
  }
  const totalFilters = getFilterCount();

  return <Row className="field-body-header">
    <div lg={3} md={3} sm={3} className="fields-search-input" >
      <SubNav.SearchBox
        placeholder="Search for Field or Crop name"
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
        onClear={() => { setSearchText(""); }}
      />
    </div>
    <Filter show={isOpen} onToggle={() => setIsOpen(!isOpen)}>
      <Filter.Toggle>
        {totalFilters && <Badge variant="warning" className="badge-filter-count">{totalFilters}</Badge>}
      </Filter.Toggle>
      <FilterBox>
        <Tab.Container defaultActiveKey="first">
          <FilterBox.Body>
            <Col sm={4} className="mt-2 pr-1">
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">
                    Fields
                    <span className="filter-count">{getFilterCount("fields")}</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">
                    Crops
                    <span className="filter-count">{getFilterCount("crops")}</span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col lg={8}>
              <Tab.Content className="mt-2 mr-3">
                <Tab.Pane eventKey="first">
                  <Filter.Options options={fields} selected={filters.fields}
                    keyname={{ value: "id", label: "name" }}
                    onSelect={(item, e) => handleSelect(item, e, "fields")}
                    selectAll={true}
                    onSelectAll={handleSelectAllFields}
                    totalLength={fields.length}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Filter.Options options={crops} selected={filters.crops}
                    keyname={{ value: "id", label: "name" }}
                    onSelect={(item, e) => handleSelect(item, e, "crops")}
                    selectAll={true}
                    onSelectAll={handleSelectAllCrops}
                    totalLength={crops.length}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </FilterBox.Body>
          <FilterBox.Footer>
            <Filter.ResetButton onClick={handleReset} />
            <Filter.ApplyButton onClick={handleApply}
              disabled={filters.fields.length === 0 && filters.crops.length === 0} />
          </FilterBox.Footer>
        </Tab.Container>
      </FilterBox>
    </Filter>
    <Col className='filter-col'>
      <Row>
        <Col className='col-auto txt'>Sort by</Col>
        <Col className='col-8'>
          <DropdownButton className='sort-by_button' variant="outline-light" id="dropdown-item-button" title={sortBy.label}>
            <Dropdown.Item as="button" onClick={() => dispatch(setSortBy({ name: 'percentage', type: 'asc', label: 'Completed % - (0% to 99%)' }))}>Completed % <span className='text-muted'>- (0% to 99%)</span></Dropdown.Item>
            <Dropdown.Item as="button" onClick={() => dispatch(setSortBy({ name: 'percentage', type: 'desc', label: 'Completed % - (99% to 0%)' }))}>Completed % <span className='text-muted'>- (99% to 0%)</span></Dropdown.Item>
            <Dropdown.Divider />
            {isEnableHarvestProjection && <>
              <Dropdown.Item as="button" onClick={() => dispatch(setSortBy({ name: 'date', type: 'asc', label: 'Worked Date - (oldest first)' }))}>Worked Date <span className='text-muted'>- (oldest first)</span></Dropdown.Item>
              <Dropdown.Item as="button" onClick={() => dispatch(setSortBy({ name: 'date', type: 'desc', label: 'Worked Date - (newest first)' }))}>Worked Date <span className='text-muted'>- (newest first)</span></Dropdown.Item>
              <Dropdown.Divider />
            </>}
            <Dropdown.Item as="button" onClick={() => dispatch(setSortBy({ name: 'name', type: 'asc', label: 'Field Name - (a to z)' }))}>Field Name <span className='text-muted'>- (a to z)</span></Dropdown.Item>
            <Dropdown.Item as="button" onClick={() => dispatch(setSortBy({ name: 'name', type: 'desc', label: 'Field Name - (z to a)' }))}>Field Name <span className='text-muted'>- (z to a)</span></Dropdown.Item>
          </DropdownButton>
        </Col>
      </Row>
    </Col>

    <Col className="total-completion-info">
      {/* {selectedWorkTypeIds.length !== 0 && <Row>
                <Col>
                    <Row className="value">430</Row>
                    <Row className="label">Total Acres</Row>
                </Col>
                <Col>
                    <Row className="value">21</Row>
                    <Row className="label">Implements</Row>
                </Col>
                <Col>
                    <Row className="value">4</Row>
                    <Row className="label">Transport</Row>
                </Col>
                <Col lg={5} md={5} sm={5}>
                    <Row className="value">30% <span className="completion-status" style={{ "--percentage": `30%` }} /></Row>
                    <Row className="label">Summary</Row>
                </Col>
            </Row>} */}
    </Col>
    {isAllPlan && <Col lg={2} md={2} sm={2} >
      <div className="avatar-input">
        <AvatarWithDropdownSelection
          list={workTypeList}
          selectedList={selectedWorkTypeIds}
          color={WORK_TYPE_COLOURS}
          idKeyValue="work_type_id"
          nameKeyValue="work_type"
          handleSelect={handleWorkType}
          disableList={selectedWorkTypeIds.length === 1 ? selectedWorkTypeIds : []} />
      </div>
    </Col>}
  </Row>
}

export default memo(FieldHeader);
